'use strict';
import React from 'react';
import checkPtsAction from '../actions/checkPtsAction';
import checkPtsStore from '../stores/checkPtsStore';
import SideMenu from '../components/sideMenu';
import NavBar from '../components/navBar';
import menuAction from '../actions/menuAction';
import Loading from '../components/loading';
import CheckPtsModal from './checkPtsComponents/CheckPtsModal';
import CheckIPModal from './checkPtsComponents/checkIPModal';

class CheckPtsSetting extends React.Component {
    constructor(props) {
        super(props);
        this.onChange = this.onChange.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.editIP = this.editIP.bind(this);
        this.addIP = this.addIP.bind(this);
        this.shouldModalClose = this.shouldModalClose.bind(this);
        this.shouldModalCloseIP = this.shouldModalCloseIP.bind(this);
        this.addLocation = this.addLocation.bind(this);
        this.editLocation = this.editLocation.bind(this);
        this.removeLocation = this.removeLocation.bind(this);
        this.removedIP = this.removedIP.bind(this);
        this.state = {
            processing: checkPtsStore.getState().processing,
            //radius: checkPtsStore.getState().radius,
            checkPoint: checkPtsStore.getState().checkPoint,
            removedCheckPoint: checkPtsStore.getState().removedCheckPoint,
            IP: checkPtsStore.getState().IP,
            removedIP: checkPtsStore.getState().removedIP,
            modalClose: false,
            modalCloseIP: false,
            index: "",
        };
    }
    componentDidMount() {
        checkPtsStore.listen(this.onChange);
        menuAction.pageNumber(15);
        if (!this.state.processing) {
            checkPtsAction.processing(true);
            //checkPtsAction.getRadius();
            checkPtsAction.getCheckPoints();
            checkPtsAction.getIP();
        }
    }
    componentWillUnmount() {
        checkPtsStore.unlisten(this.onChange);
    }
    onChange(state) {
        this.setState({
            processing: state.processing,
            //radius: state.radius,
            checkPoint: state.checkPoint,
            removedCheckPoint: state.removedCheckPoint,
            IP: state.IP,
            removedIP: state.removedIP
        });
    }
    shouldModalClose(data) {
        this.setState({
            modalClose: data
        });
    }
    shouldModalCloseIP(data) {
        this.setState({
            modalCloseIP: data
        });
    }
    handleClick(e) {
        if (this.state.processing) return;

        checkPtsAction.processing(true);
        //checkPtsAction.updateRadius(this.state.radius);
        checkPtsAction.updateCheckPoint(this.state.checkPoint, this.state.removedCheckPoint,
            this.state.IP, this.state.removedIP);
    }
    editIP(e) {
        let index = parseInt(e.currentTarget.getAttribute("data-index"));
        this.setState({ index: index, modalCloseIP: true });
    }
    removedIP(e) {
        let index = parseInt(e.currentTarget.getAttribute("data-index"));

        let IP = this.state.IP;
        let removedIP = this.state.removedIP;

        if (this.state.IP[index]._id) {
            removedIP = removedIP.concat(this.state.IP[index]);
        }
        IP.splice(index, 1);
        checkPtsAction.ip(IP);
        checkPtsAction.removedIP(removedIP);
    }
    addIP(e) {
        this.setState({
            index: "",
            modalCloseIP: true
        });
    }
    addLocation(e) {
        this.setState({
            index: "",
            modalClose: true
        });
    }
    removeLocation(e) {
        let index = parseInt(e.currentTarget.getAttribute("data-index"));

        let checkPoint = this.state.checkPoint;
        let removedCheckPoint = this.state.removedCheckPoint;
        //check if index has id
        if (this.state.checkPoint[index]._id) {
            removedCheckPoint = removedCheckPoint.concat(this.state.checkPoint[index]);
        }
        checkPoint.splice(index, 1);
        checkPtsAction.checkPoint(checkPoint);
        checkPtsAction.removedCheckPoint(removedCheckPoint);
    }
    editLocation(e) {
        let index = parseInt(e.currentTarget.getAttribute("data-index"));
        this.setState({ index: index, modalClose: true });
    }
    renderIP() {
        return this.state.IP.map((ip, index) => {
            return (
                <div className="cp-wp" key={index}>
                    <div className="jps-rev glyphicon glyphicon-remove" data-index={index} onClick={this.removedIP}></div>
                    <div className="cp-title">{ip.officeName}</div>
                    <div className="cp-coordinate">
                        <label className="control-label">IP Range</label>
                        <div className="cp-lng">
                            Lower Range: &nbsp;
                            {ip.lowerRange.length > 0 ?
                                ip.lowerRange[0] + " . " + ip.lowerRange[1] + " . " + ip.lowerRange[2] + " . " + ip.lowerRange[3] : ""}
                        </div>
                        <div className="cp-lat">
                            Upper Range: &nbsp;
                            {ip.upperRange.length > 0 ?
                                ip.upperRange[0] + " . " + ip.upperRange[1] + " . " + ip.upperRange[2] + " . " + ip.upperRange[3] : ""}
                        </div>
                    </div>
                    <div className="btn btn-default btn-xs cp-edit" data-index={index} onClick={this.editIP}>Edit</div>
                </div>
            );
        });
    }
    renderLocation() {
        let location = this.state.checkPoint.map((location, index) => {
            return (
                <div className="cp-wp" key={index}>
                    <div className="jps-rev glyphicon glyphicon-remove" data-index={index} onClick={this.removeLocation}></div>
                    <div className="cp-title">{location.location}</div>
                    <div className="cp-coordinate">
                        <label className="control-label">Coordinates</label>
                        <div className="cp-lng">
                            Longitude: &nbsp;
                            {location.geoLocation.coordinates[0]}
                        </div>
                        <div className="cp-lat">
                            Latitude: &nbsp;
                            {location.geoLocation.coordinates[1]}
                        </div>
                    </div>
                    <div className="cp-radius">
                        <div className="cp-radius">Radius (meter): {location.radius ? location.radius : 0}</div>
                    </div>
                    <div className="btn btn-default btn-xs cp-edit" data-index={index} onClick={this.editLocation}>Edit</div>
                </div>
            );
        });

        return location;
    }
    render() {
        let modal, modalIP;
        if (this.state.modalClose) {
            modal = <CheckPtsModal modalClose={this.state.modalClose} shouldModalClose={this.shouldModalClose} index={this.state.index}
                checkPoint={this.state.checkPoint} removedCheckPoint={this.state.removedCheckPoint} />
        }
        if (this.state.modalCloseIP) {
            modalIP = <CheckIPModal modalClose={this.state.modalCloseIP} shouldModalClose={this.shouldModalCloseIP} index={this.state.index}
                IP={this.state.IP} removedIP={this.state.removedIP} />
        }
        let s = this.state;
        return (
            <div className="container-fluid content">
                <div className="row">
                    <NavBar {...this.props} />
                    <SideMenu {...this.props} />
                    <div className=" col-md-10  col-sm-8 us-form">
                        <div className="row">
                            <div className="col-sm-12">
                                <div className="atd-hd">
                                    <h4><b>Location Management</b></h4>
                                    <br />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-4">
                                <div>
                                    <label className="control-label">Locations:</label>
                                    <button className="btn btn-default btn-xs jps-add " onClick={this.addLocation}>Add</button>
                                </div>
                                <small>Employee time in/out location (Other than managing estate) </small>
                                {this.renderLocation()}
                            </div>
                            <div className="col-sm-4">
                                <div>
                                    <label className="control-label">IP Address</label>
                                    <button className="btn btn-default btn-xs jps-add " onClick={this.addIP}>Add</button>
                                </div>
                                <small>Employee time in/out IP address (for web portal)</small>
                                {this.renderIP()}
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-sm-3">
                                <br />
                                <br />
                                <button className="btn btn-warning" onClick={this.handleClick}>Save</button>
                            </div>
                        </div>
                    </div>
                </div>
                {modal}
                {modalIP}
                <Loading processing={this.state.processing} />
            </div>
        );
        /*
        <div className="col-sm-4">
            <div className="atd-hd">
                <h4><b>Location Management</b></h4>
            </div>
            <br />

            <div className="form-group">
                <label htmlFor="radius">Maximum Estate Radius</label>
                <small><br />Estates are detectable within the radius (meter)</small>
                <input type="number" className="form-control" id="radius" value={this.state.radius}
                    placeholder="meter" onChange={this.handleEdit} />
            </div>

        </div>
        */
    }

}
export default CheckPtsSetting;


// WEBPACK FOOTER //
// ./app/setComponents/checkPtsSetting.js